const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class Breakthrough extends Action {
    constructor(age){
        super(
            age,
            ActionNames.Breakthrough, 
            `Develop a technology. After you pay the science cost, score ${Breakthrough.GetScienceAmount(age)} science.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetScienceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
        }
    }
}

module.exports = Breakthrough;